var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTools = function SvgTools(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.707 3.293a1 1 0 0 0-1.414 0l-2 2A1 1 0 0 0 11 6v2.586l-7.707 7.707a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414 0L15.414 13H18a1 1 0 0 0 .707-.293l2-2a1 1 0 0 0 0-1.414zM13 7.414v-1l1-1L18.586 10l-1 1h-1zM14.586 12 12 9.414l-5 5L9.586 17zm-6 6L6 15.414 5.414 16 8 18.586z",
    clipRule: "evenodd"
  })));
};
export default SvgTools;